// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"203":"f56cb37f7e6bba3f","538":"edd158b41e9bd1ef","894":"a3e464db6f546bfd","983":"02a209febdd48774"}[chunkId] + ".js";
};